export class ProductWarrantyUpsertModel {
  MachineProductId: number;
  LaborWarrantyDays?: number;
  PartWarrantyDays?: number;
  Issues: string;
  Column: string[];
}